module.exports = __webpack_public_path__ + "static/media/dong-xie-1vwOXJXxbrE-unsplash.2c0a65ac.webp";